import type { WardrobeCategoryData, WardrobeItem } from '@/types';
import type { GenerationResult } from '@/types/generation';
import type { LibraryCharacter, LookVariant } from '@/types/library';

/** Flatten all user-uploaded items across every wardrobe category. */
export function getUserUploadedItems(categories: WardrobeCategoryData[]): WardrobeItem[] {
  return categories.flatMap(cat => cat.items.filter(item => item.isUserUploaded));
}

/** Build a minimal GenerationResult from a LookVariant so the preview can display the generated image. */
export function buildSyntheticResult(look: LookVariant, char: LibraryCharacter): GenerationResult {
  return {
    id: look.id,
    imageUrl: look.generatedImageUrl,
    driveUid: look.driveUidGenerated,
    timestamp: look.timestamp,
    characterId: char.id,
    quality: {} as GenerationResult['quality'],
    request: {
      character: {
        imageUrl: char.characterImageUrl,
        imageFile: null,
        imageAspectRatio: null,
        gender: char.gender,
        selectedStyle: look.selectedStyle,
        selectedPose: look.selectedPose,
        selectedBackground: look.selectedBackground,
        selectedHairstyle: look.selectedHairstyle,
        selectedHairColor: look.selectedHairColor,
        isIdentityLocked: true,
        selectedRetouchPresets: look.selectedRetouchPresets ?? {},
      },
      wardrobeItems: look.selectedItems,
      viewMode: 'standard' as const,
      lookFolder: '',
    },
  };
}
